// extracted by mini-css-extract-plugin
export var fadeIn = "_8r-0";
export var panelInner = "_8r-2";
export var panelOuter = "_8r-1";